import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

type UsersMeResponse = {
  user: {
    id: number;
    email: string;
  };
};

type UsersDeleteResponse = {
  status: string;
  messages?: string[];
  user?: Record<string, never>;
};

@Injectable({
  providedIn: 'root',
})
export class UsersApiService {
  private readonly apiBase = environment.apiBase || 'http://localhost:13000';

  constructor(private readonly http: HttpClient) {}

  me(token: string): Observable<UsersMeResponse> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.get<UsersMeResponse>(`${this.apiBase}/api/users/me`, { headers });
  }

  deleteMe(token: string): Observable<UsersDeleteResponse> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.delete<UsersDeleteResponse>(`${this.apiBase}/api/users/me.json`, { headers });
  }
}
